// @flow
import TableMarks from './TableMarks';

export default TableMarks;
